import React, { Component } from "react";
import { Table, Card, Row, Col, Button, Image } from "react-bootstrap";
import AddState from "./AddState";
import DeleteState from "./DeleteState";
import EditState from "./EditState";
import "./State.css";
import ReactPaginate from "react-paginate";
class State extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ShowAddModel: false,
      showEdit: false,
      ItemList: "",
      showDelete: false,
      searchShow: false,
      searchState: "",
      perPage: 10,
      page: 0,
      Spage: 0,
      perPageS: 10,
      filterValue: "All",
      FilterTable: false,
    };
    this.closeDeleteModel = this.closeDeleteModel.bind(this);
    this.editmodel = this.editmodel.bind(this);
    this.closeEdtModel = this.closeEdtModel.bind(this);
    this.showDeleteModel = this.showDeleteModel.bind(this);
  }
  componentDidMount() {
    this.props.stateViewList();
  }
  editmodel = (item) => {
    this.setState({
      ItemList: item,
      showEdit: true,
    });
  };

  closeEdtModel = () => {
    this.setState({
      showEdit: false,
    });
  };

  showDeleteModel = (item) => {
    this.setState({
      showDelete: true,
      DeleteItems: item,
    });
  };
  closeDeleteModel = () => {
    this.setState({
      showDelete: false,
    });
  };
  handleShowAdd = () => {
    this.setState({
      ShowAddModel: true,
      searchShow: false,
    });
  };
  handleCloseView = () => {
    this.setState({ ShowAddModel: false });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;

    this.props.stateSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  handlePageSearchClick = (e) => {
    const selectedSearchPage = e.selected;
    this.setState({ Spage: selectedSearchPage });

    this.props.stateSearch({
      searchState: this.state.searchState,
      Spage: selectedSearchPage + 1,
    });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };

  SearchOnChange = (event) => {
    let state = event.target.value;

    this.setState({
      searchShow: true,
      searchState: state,
      FilterTable: false,
      filterValue: "All",
    });
    this.props.stateSearch({
      searchState: state,
      Spage: this.state.Spage + 1,
    });
  };

  render() {
    let p = this.state.page + 1;
    const count = this.props.stateDtlsCount && this.props.stateDtlsCount;
    let statePageCount = Math.ceil(count / this.state.perPage);

    let p2 = this.state.Spage + 1;
    const SearchCount =
      this.props.statesSearchCount && this.props.statesSearchCount;
    const SearchPageCount = Math.ceil(SearchCount / this.state.perPageS);
    return (
      <div>
        <div>
          <div>
            <div className="state_Div">
              <Card>
                <Card.Header>
                  <Row
                    className="align-items-center justify-content-between w-100 tableHeaderRow"
                  >
                    <Col xs="auto">
                      <h3>State</h3>
                    </Col>

                    <Col xs="auto">
                      <div className="userInput">
                        <i className="fa fa-search fa-lg userIcon"></i>
                        <input
                          type="text"
                          placeholder="Search by State"
                          onChange={this.SearchOnChange}
                        />
                      </div>
                    </Col>

                    <Col xs="auto">
                      <div className="totalRecord">
                        <i
                          className="cui-note icons"
                          style={{ fontSize: "15px" }}
                        ></i>
                        <span
                          style={{
                            padding: "5px",
                            fontWeight: 600,
                            fontSize: "18px",
                            opacity: ".7",
                          }}
                        >
                          {count === undefined && SearchCount === undefined ? (
                            0
                          ) : (
                            <span>
                              {!this.state.searchShow && count}
                              {this.state.searchShow && SearchCount}
                            </span>
                          )}
                        </span>
                        <span style={{ opacity: ".7" }}>Results</span>
                      </div>
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body>
                  <Button
                    style={{ marginBottom: "15px" }}
                    onClick={() => this.handleShowAdd()}
                  >
                    <i className="fa fa-plus fa-md"></i>
                    <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                      ADD
                    </span>
                  </Button>
                  <AddState
                    ShowAddModel={this.state.ShowAddModel}
                    handleClose={this.handleCloseView}
                    addState={this.props.addState}
                    resetPage={this.resetPage}
                  />
                  {!this.state.searchShow && !this.state.FilterTable && (
                    <div className="StateMainTable">
                      <Table
                        responsive
                        striped
                        className="cmnMainTable"
                        bordered
                      >
                        <thead>
                          <tr className="cmnMainTableHd">
                            <th style={{ width: "60px" }}>SL NO</th>
                            <th>STATE TYPE</th>
                            <th>STATE CODE</th>
                            <th>STATE NAME</th>
                            <th>CAPITAL</th>
                            <th>LATITUDE</th>
                            <th>LONGITUDE</th>
                            <th>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.stateList &&
                            this.props.stateList.map((item, i) => (
                              <tr key={i}>
                                <td>{10 * (p - 1) + i + 1}</td>
                                {}
                                <td className="cmn_Cap">{item.type}</td>
                                <td className="cmn_Cap">{item.code}</td>
                                <td className="cmn_Cap">{item.name}</td>
                                <td className="cmn_Cap">{item.capital}</td>
                                <td className="cmn_Cap">
                                  {item.coordinates[0]}
                                </td>
                                <td className="cmn_Cap">
                                  {item.coordinates[1]}
                                </td>
                                <td className="cmnViewIcon">
                                  {" "}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <i
                                      className="fa fa-edit fa-lg "
                                      onClick={() => this.editmodel(item)}
                                    ></i>
                                    <EditState
                                      editShow={this.state.showEdit}
                                      closemodel={this.closeEdtModel}
                                      ItemList={this.state.ItemList}
                                      editState={this.props.editState}
                                      resetPage={this.resetPage}
                                    />
                                    <i
                                      className="fa fa-trash fa-lg "
                                      style={{
                                        paddingLeft: 10,
                                      }}
                                      onClick={() => this.showDeleteModel(item)}
                                    ></i>
                                    <DeleteState
                                      showDelete={this.state.showDelete}
                                      DeleteItems={this.state.DeleteItems}
                                      closeDeleteModel={this.closeDeleteModel}
                                      deleteState={this.props.deleteState}
                                      resetPage={this.resetPage}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                  {/* ------------------------search---------------------- */}
                  {this.state.searchShow && !this.state.FilterTable && (
                    <div className="StateMainTable">
                      <Table
                        responsive
                        striped
                        className="cmnMainTable"
                        bordered
                      >
                        <thead>
                          <tr className="cmnMainTableHd">
                            <th style={{ width: "200px" }}>SL NO</th>
                            <th style={{ width: "200px" }}>STATE TYPE</th>
                            <th style={{ width: "200px" }}>STATE CODE</th>
                            <th style={{ width: "200px" }}>STATE NAME</th>
                            <th style={{ width: "200px" }}>CAPITAL</th>
                            <th style={{ width: "200px" }}>LATITUDE</th>
                            <th style={{ width: "200px" }}>LONGITUDE</th>
                            <th style={{ width: "200px" }}>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.stateSearchList &&
                            this.props.stateSearchList.map((item, i) => (
                              <tr key={i}>
                                <td>{10 * (p2 - 1) + i + 1}</td>
                                {}
                                <td className="cmn_Cap">{item.type}</td>
                                <td className="cmn_Cap">{item.code}</td>
                                <td className="cmn_Cap">{item.name}</td>
                                <td className="cmn_Cap">{item.capital}</td>
                                <td className="cmn_Cap">
                                  {item.coordinates[0]}
                                </td>
                                <td className="cmn_Cap">
                                  {item.coordinates[1]}
                                </td>
                                <td className="cmnViewIcon">
                                  {" "}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <i
                                      className="fa fa-edit fa-lg"
                                      onClick={() => this.editmodel(item)}
                                    ></i>
                                    <EditState
                                      editShow={this.state.showEdit}
                                      closemodel={this.closeEdtModel}
                                      ItemList={this.state.ItemList}
                                      editState={this.props.editState}
                                      resetPage={this.resetPage}
                                    />
                                    <i
                                      className="fa fa-trash fa-lg"
                                      style={{
                                        paddingLeft: 10,
                                      }}
                                      onClick={() => this.showDeleteModel(item)}
                                    ></i>
                                    <DeleteState
                                      showDelete={this.state.showDelete}
                                      DeleteItems={this.state.DeleteItems}
                                      closeDeleteModel={this.closeDeleteModel}
                                      deleteState={this.props.deleteState}
                                      resetPage={this.resetPage}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  )}

                  {!this.state.searchShow &&
                    (this.props.stateList === undefined ||
                      (this.props.stateList &&
                        this.props.stateList.length === 0)) && (
                      <div>
                        <div className="noDataImgDiv">
                          <Image
                            className="noDataImg"
                            src={require("../../../assets/img/nodata4.png")}
                          />
                        </div>
                        <div className="noDataTextDiv">No States Found</div>
                      </div>
                    )}

                  {this.state.searchShow &&
                    (this.props.stateSearchList === undefined ||
                      (this.props.stateSearchList &&
                        this.props.stateSearchList.length === 0)) && (
                      <div>
                        <div className="noDataImgDiv">
                          <Image
                            className="noDataImg"
                            src={require("../../../assets/img/nodata4.png")}
                          />
                        </div>
                        <div className="noDataTextDiv">No States Found</div>
                      </div>
                    )}
                </Card.Body>
                {!this.state.searchShow &&
                statePageCount &&
                statePageCount > 1 ? (
                  <div className="paginationDiv">
                    <ReactPaginate
                      forcePage={this.state.page}
                      previousLabel={"Prev"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={statePageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={this.handlePageClick}
                      containerClassName={"pagination flex-wrap"}
                      subContainerClassName={"pages pagination"}
                      activeClassName={"active"}
                    />
                  </div>
                ) : null}

                {this.state.searchShow &&
                SearchPageCount &&
                SearchPageCount > 1 ? (
                  <div className="paginationDiv">
                    <ReactPaginate
                      forcePage={this.state.Spage}
                      previousLabel={"Prev"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={SearchPageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={this.handlePageSearchClick}
                      containerClassName={"pagination flex-wrap"}
                      subContainerClassName={"pages pagination"}
                      activeClassName={"active"}
                    />
                  </div>
                ) : null}
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default State;
